import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ClickOutsideDirective } from './click-outside.directive'
import { TooltipWhenTruncatedDirective } from './tooltip-when-truncated/tooltip-when-truncated.directive'

@NgModule({
  declarations: [
    ClickOutsideDirective,
    TooltipWhenTruncatedDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ClickOutsideDirective,
    TooltipWhenTruncatedDirective
  ]
})
export class DirectivesModule { }
